import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


export var mutation = gql`
  mutation setAssetOwnerLegalEntity($organizationId: UUID!,$assetId: UUID!, $legalEntityId: UUID!) {
    setAssetOwnerLegalEntity(organizationId: $organizationId, assetId: $assetId, legalEntityId: $legalEntityId) 
  }  
`;

export function apiSetOwningLegalEntityId(organizationId, assetId, legalEntityId) {

    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");
        client
            .mutate({
                mutation: mutation,
                variables: {organizationId, assetId, legalEntityId},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                let data = result.data.setAssetOwnerLegalEntity;
                if(data) resolve(data);
                else throw "Unable to set";
            })
            .catch((err) => {
                toast.error("Api Error, Unable to set owning legal entity");
                reject(err);
            })
    });
}
